import React from 'react';

import { classes } from './classes';

/**
 * @param {React.ComponentProps<"div">} props
 */
export const Actions = ({ children, ...props }) => (
  <div className={classes.actions} {...props}>
    {children}
  </div>
);
